<template>
    <div class="contract-page">
        <van-sticky>
            <div class="search-bar" style="margin-bottom: 10px;">
                <van-search v-model="filters.contractNumber" placeholder="请输入搜索合同编号" @search="onSearch" />
                <van-button type="primary" size="small" @click="showFilterPopup = true">筛选</van-button>
            </div>
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                <van-checkbox-group v-model="selectedContracts" @change="onSelectChange">
                    <div v-for="item in list" :key="item.contractNumber" class="card">
                        <div class="card-body">
                            <div class="row"><label>合同编号</label>
                                <div class="value">{{ item.contractNumber }}</div>
                            </div> 
                            <div class="row"><label>合同状态</label>
                                <div class="value">
                                    <el-tag :type="getStatusColor(item.status, 'tagType')"
                                        :style="{ color: getStatusColor(item.status, 'color'), 'background-color': getStatusColor(item.status, 'backgroundColor') }">
                                        {{ getStatusColor(item.status, 'name') }}</el-tag>
                                </div>
                            </div>
                            <div class="row" v-if="item.status === 'DEFEAT'"><label>驳回原因</label>
                                <div class="value">{{ item.rejectionReason }}</div>
                            </div>
                            <div class="row"><label>合同名称</label>
                                <div class="value">{{ item.contractName }}</div>
                            </div>
                            <div class="row"><label>合同分类</label>
                                <div class="value">{{ item.contractType }}</div>
                            </div>
                            <div class="row"><label>合同类型</label>
                                <div class="value">{{ item.projectType }}</div>
                            </div>
                            <div class="row"><label>合同金额</label>
                                <div class="value">{{ item.contractAmount }}</div>
                            </div>
                            <div class="row" v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(item.contractType)">
                                <label>增值金额</label>
                                <div class="value">{{ item.addedAmount }}（{{ getProportion(item.contractAmount,
                                    item.addedAmount) }}）</div>
                            </div>
                            <div class="row"><label>销售</label>
                                <div class="value">{{ item.sales.name }}</div>
                            </div>
                            <div class="row"><label>客户联系人</label>
                                <div class="value">
                                    <span v-if="item?.customerContacts?.contactName">{{
                                        item.customerContacts.contactName
                                        }}</span>
                                    <span v-else class="missing">系统内未找到</span>
                                </div>
                            </div>
                            <div class="row"><label>客户单位</label>
                                <div class="value">{{item.customerContacts.companyName}}</div>
                            </div>
                            <div class="row"><label>受托方</label>
                                <div class="value">{{ item.baseCompany?.companyName }}</div>
                            </div>
                            <div class="row"><label>签订时间</label>
                                <div class="value">{{ item.contractDraftingDate }}</div>
                            </div>
                            <div class="ops">
                                <van-checkbox :name="item.id" shape="square"></van-checkbox>
                                <van-button size="mini" v-if="item.status === 'SUCCESS' && ['FORMAL'].includes(item.contractType)
                                    && ['测序分析'].includes(item.projectType)
                                    && item['contractRelatedStatus']['receiptStatus'] !== 'PAYMENT_RECEIVED'
                                " type="primary" @click="startSign(item)">发起签署</van-button>
                                <van-button size="mini" plain @click="download(item.id)">下载合同</van-button>
                                <van-button size="mini" plain @click="viewDetail(item)">查看</van-button>
                            </div>
                        </div>
                    </div>
                </van-checkbox-group>
            </van-list>
        </van-pull-refresh>
        <van-submit-bar v-show="showBatchActions" button-type="primary" button-text="批量签署" @submit="batchSign">
            <van-button round @click="clearSelection">取消选择</van-button>
            <template #tip>
                已选择 {{ selectedContracts.length }} 份合同
            </template>
        </van-submit-bar>
        <van-popup v-model="showFilterPopup" position="right" :style="{ width: '85%', height: '100%' }">
            <van-nav-bar title="筛选条件" left-text="取消" right-text="确定" @click-left="showFilterPopup = false"
                @click-right="handleFilterConfirm" />
            <div class="filter-content">
                <van-field label-width="5.3em" label="合同范围">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="activeTab" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="all">全部合同</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="audit">待审核</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="file">待邮寄</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="signApply">待签署</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="receipt">未到款</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="failure">退回合同</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="24">
                                    <van-radio name="record">未开发票/部分开票</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label-width="5.3em" label="合同编号" v-model="filters.contractNumber" placeholder="请输入合同编号" />
                <van-field label-width="5.3em" label="合同名称" v-model="filters.contractName" placeholder="请输入合同名称" />
                <van-field label-width="5.3em" label="合同分类">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="filters.contractType" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="PREPAYMENTS">预付款</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="FORMAL">正式</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="CHARGEBACKS">扣款</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="IMPORT_PREPAYMENTS">老系统预付款</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="DEVELOPMENT">研发</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="ADVANCE_PAYMENT_TRANSFER">预付款转移</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label-width="5.3em" label="合同状态">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="filters.status" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="APPLYING">待审核</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="SUCCESS">已通过</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="DEFEAT">已驳回</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="DERELICT">已终止</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="DEVELOPMENT">研发</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="ADVANCE_PAYMENT_TRANSFER">预付款转移</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label-width="5.3em" label="发票开票">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="filters.invoicingStatus" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="NOT_APPLYING">未申请</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="NOT_INVOICED">未开票</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="PARTIAL_INVOICING">部分开票</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="ALL_INVOICED">全部开票</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field label-width="5.3em" label="原始数据">
                    <template #input>
                        <van-radio-group style="width: 100%;" v-model="filters.rawDataReleaseStatus" icon-size="15px">
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="NOT_RELEASED">未释放</van-radio>
                                </van-col>
                                <van-col span="12">
                                    <van-radio name="PARTIAL_RELEASE">部分释放</van-radio>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="12">
                                    <van-radio name="ALL_RELEASE">已释放</van-radio>
                                </van-col>
                            </van-row>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field label-width="5.3em" label="项目类型" v-model="filters.projectType" placeholder="请输入项目类型" />
                <van-field label-width="5.3em" label="销售名称" v-model="filters.salesName" placeholder="请输入销售名称" />    
                <van-field label-width="5.3em" label="客户联系人" v-model="filters.customerContactsName" placeholder="请输入客户联系人" />

                <van-field label-width="5.3em" label="客户单位" v-model="filters.customerCompanyName"
                    placeholder="请输入客户单位" />
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getContractPage, attachmentContract } from "@/api/dilivery/sales/contract";
import { saveDataToLocalStorage, getDataInLocalStorage } from "@/utils/localStorage";
import { getProportion } from "@/utils/float_decimal";
import { getStatusColor } from "@/color";
const baseURL = process.env.VUE_APP_BASE_API;

export default {
    name: "Contract",
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            page: {
                currentNum: 1,
                pageSize: 10,
                total: 0
            },
            loadding: false,
            sortConditionTag: [],
            showFilterPopup: false,
            filters: {
                contractNumber: '',
                contractName: '',
                contractType: '',
                status: '',
                projectType: '',
                salesName: '',
                customerCompanyName: '',
                customerContactsName: '',
            },
            selectedContracts: [], // 添加选中的合同列表
            showBatchActions: false, // 控制批量操作按钮显示
            activeTab: 'signApply',
            tabOptions: [
                { text: '全部合同', value: 'all' },
                { text: '待审核', value: 'audit' },
                { text: '待邮寄', value: 'file' },
                { text: '未开发票/部分开票', value: 'record' },
                { text: '未到款', value: 'receipt' },
                { text: '退回合同', value: 'failure' },
                { text: '待签署', value: 'signApply' }
            ]
        };
    },
    mounted() {
        this.getData(true);
    },
    methods: {
        getStatusColor,
        // 处理选择变化
        onSelectChange() {
            this.showBatchActions = this.selectedContracts.length > 0;
        },
        // 清除选择
        clearSelection() {
            this.selectedContracts = [];
            this.showBatchActions = false;
        },
        // 批量签署
        batchSign() {
            const selectedContracts = this.list.filter(item => this.selectedContracts.includes(item.id));
            let selectable = selectedContracts.filter(item => item.status === 'SUCCESS'
                && ['FORMAL'].includes(item.contractType)
                && ['测序分析'].includes(item.projectType)
                && item['contractRelatedStatus']['receiptStatus'] !== 'PAYMENT_RECEIVED')
            let checkAble = selectedContracts.filter(item => item.status !== 'SUCCESS'
                || !['FORMAL'].includes(item.contractType)
                || !['测序分析'].includes(item.projectType)
                || item['contractRelatedStatus']['receiptStatus'] === 'PAYMENT_RECEIVED')
            if (checkAble.length > 0) {
                this.$toast('合同编号为' + checkAble[0].contractNumber + '的合同暂无法申请签署');
                return
            }
            if (selectable.length === 0) {
                this.$toast('请选择要签署的合同');
                return
            }
            // 检查销售是否一致
            const firstSalesId = selectedContracts[0].sales?.id;
            const allSameSales = selectedContracts.every(contract =>
                contract.sales?.id === firstSalesId
            );

            if (!allSameSales) {
                this.$toast('所选合同的销售必须一致');
                return;
            }

            // 保存选中的合同并跳转
            saveDataToLocalStorage('mSignData', JSON.stringify(selectedContracts));
            this.$router.push({ path: '/signContract' });
        },

        getProportion,
        onCancel() {
            this.filters.contractNumber = '';
        },
        handleFilterConfirm() {
            this.showFilterPopup = false;
            this.getData(true);
        },
        async getData(reset = false) {
            if (reset) {
                this.page.currentNum = 1;
                this.list = [];
                this.finished = false;
            }
            this.loadding = true;
            const params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize
            };
            if (this.sortConditionTag.length > 0) {
                params["order"] = this.sortConditionTag.map(sc => sc.colName + "." + sc.order).join(",");
            }
            let sendData = { };
            switch (this.activeTab) {
                case 'audit':
                    sendData["query#status.EQ"] = "APPLYING";
                    break;
                case 'file':
                    sendData["query#mailStatus.EQ"] = "NOT_APPLYING";
                    sendData["query#status.EQ"] = "SUCCESS";
                    sendData["query#contractType.IN"] = "PREPAYMENTS,FORMAL,CHARGEBACKS";
                    sendData["query#contractType.NE"] = "CHARGEBACKS";
                    break;
                case 'record':
                    sendData["contractInvoiceFlag"] = false;
                    sendData["query#status.EQ"] = "SUCCESS";
                    sendData["query#contractType.IN"] = "PREPAYMENTS,FORMAL";
                    break;
                case 'receipt':
                    sendData["query#contractType.IN"] = "PREPAYMENTS,FORMAL";
                    sendData["query#receiptStatus.EQ"] = "NOT_RECEIVED";
                    break;
                case 'failure':
                    sendData["query#status.EQ"] = "DEFEAT";
                    break;
                case 'signApply':
                    sendData["signFlag"] = true;
                    break;
                default:
                    break;
            }
            sendData = this.searchDataFilter(sendData);
            try {
                const res = await getContractPage(params, sendData);
                if (res.code === 200) {
                    const records = Array.isArray(res.data.records) ? res.data.records : [];
                    if (this.page.currentNum === 1) {
                        this.list = records;
                    } else {
                        this.list = this.list.concat(records);
                    }
                    this.page.currentNum = parseInt(res.data.current);
                    this.page.pageSize = parseInt(res.data.size);
                    this.page.total = parseInt(res.data.total);
                    // 结束判断
                    this.finished = this.list.length >= this.page.total;
                }
            } catch (err) {
                console.error("获取合同列表失败", err);
            } finally {
                this.loadding = false;
                this.refreshing = false;
                this.loading = false;
            }    
        },
        searchDataFilter(sendData) {
            if (this.filters.contractNumber) sendData["query#contractNumber.LIKE"] = this.filters.contractNumber;
            if (this.filters.contractName) sendData["query#contractName.LIKE"] = this.filters.contractName;
            if (this.filters.contractType) sendData["query#contractType.EQ"] = this.filters.contractType;
            if (this.filters.status) sendData["query#status.EQ"] = this.filters.status;
            if (this.filters.projectType) sendData["query#projectType.LIKE"] = this.filters.projectType;
            if (this.filters.salesName) sendData["query#salesName.LIKE"] = this.filters.salesName;
            if (this.filters.customerCompanyName) sendData["customerCompanyName"] = this.filters.customerCompanyName;
            if (this.filters.customerContactsName) sendData["customerContactsName"] = this.filters.customerContactsName;
            return sendData;
        },
        onTabChange(value) {
            this.activeTab = value;
            this.getData(true);
        },
        // 下拉刷新
        onRefresh() {
            this.refreshing = true;
            this.getData(true);
        },
        // 底部加载更多
        onLoadMore() {
            if (this.finished || this.loadding) {
                this.loading = false;
                return
            };
            this.page.currentNum = this.page.currentNum + 1;
            this.getData(false);
        },
        onSearch() {
            // 搜索时重置分页并拉取
            this.getData(true);
        },
        // 发起签署（跳转到签署页面并传参）
        startSign(item) {
            // 将当前选中合同保存到本地，签署页面可读取
            saveDataToLocalStorage('mSignData', JSON.stringify([item]));
            this.$router.push({ path: '/signContract' });
        },
        // 查看详情（跳转到查看签署信息页面）
        viewDetail(item) {
            saveDataToLocalStorage('mSignData', JSON.stringify([item]));
            this.$router.push({ path: '/showSignInfo' });
        },
        download(id) {
            try {
                const url = `${baseURL}/sequencing-contract/attachment/${id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`;
                const a = document.createElement('a');
                a.href = url;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } catch (e) {
                console.error(e);
            }
        }
    }
};
</script>

<style scoped>
.contract-page {
    padding: 12px;
    padding-bottom: calc(12px + constant(safe-area-inset-bottom));
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    background: #f7f8fa;
    min-height: calc(100vh - 50px);
    box-sizing: border-box;
}

.card {
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(100, 101, 103, 0.12);
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
}
.row:last-child {
    border-bottom: none;
}
.row label {
    color: #969799;
    width: 100px;
    font-size: 14px;
    font-weight: 500;
}

.row .value {
    color: #323233;
    flex: 1;
    text-align: right;
    font-size: 14px;
    font-weight: 500;
    word-break: break-all;
}

.ops {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #ebedf0;
}
.ops .van-button {
    min-width: 70px;
    height: 32px;
    line-height: 30px;
    border-radius: 16px;
}

.filter-content {
 
    height: calc(100% - 46px);
    overflow-y: auto;
}




.van-submit-bar {
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.van-field {
  
    border-radius: 8px;
}

.van-cell-group {
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
}

.van-cell {
    padding: 12px 16px;
 
}


.search-bar {
    display: flex;
    gap: 12px;
    align-items: center;
    background: #fff;
    padding: 16px;

    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
}

.van-search {
    flex: 1;
    
}

.van-search__content {
    padding: 0;
    border-radius: 20px;
}

.van-dropdown-menu__bar {
    box-shadow: none;
}


.van-dropdown-menu__title {
    font-size: 14px;
    color: #323233;
    font-weight: 500;
}

.van-dropdown-menu__item {
    font-size: 14px;
}

.van-dropdown-menu {
    margin-top: 0px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(100, 101, 103, 0.08);
}

.missing {
    color: #dd6161;
}
</style>